import React, { useContext, useMemo } from "react";
import { AuthContext, IntlContext, FlashContext } from "context";
import formatErrorResponse from "helpers/form/formatErrorResponse";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import {Form} from "react-final-form";
import Button from "ui/Button";
import arrayMutators from "final-form-arrays";
import { Checkbox, Slider } from "components/Form/Field";
import { updateProfilePreferences } from "hooks/profile";

const MyPreferences: React.FC = () => {
    const intl = useContext(IntlContext);
    const flashMessage = useContext(FlashContext);
    const { account, updateAccount } = useContext(AuthContext);

    type PreferencesValues = {
        email_alerts?: unknown;
        notification_alerts?: unknown;
        travel_range?: number;
    };

    const isRecord = (value: unknown): value is Record<string, unknown> =>
        typeof value === "object" && value !== null;

    const initialValues = useMemo(() => {
        return {
            email_alerts: account?.user.email_alerts,
            notification_alerts: account?.user.notification_alerts,
            travel_range: account?.resources?.provider[0].travel_range
        };
    }, [account]);

    const onSubmit = async (values: PreferencesValues) => {
        try {
            await updateProfilePreferences(account!.user.id, values);
            updateAccount();
            flashMessage?.addSuccess(intl.formatMessage("profile.user.data.update"));
        } catch (err: unknown) {
            if (isRecord(err) && "response" in err && isRecord(err.response) && "data" in err.response) {
                const responseData = err.response.data;
                if (isRecord(responseData) && "data" in responseData) {
                    return formatErrorResponse(responseData as { data: unknown });
                }
            }
            throw err;
        }
    };

    return (
        <Form
            initialValues={initialValues}
            onSubmit={onSubmit}
            mutators={{ ...arrayMutators }}
            render={({ handleSubmit, submitting, form: _form }) => (
                <form onSubmit={handleSubmit} className="register__form margin-top--5">
                    <div className="grid--12 grid--has-gutter-3x">
                        <div className="grid__col--6 grid__col--small-12">
                            <h3 className="text-color--primary bold">Mes alertes</h3>
                        </div>
                        <div className="grid__col--6 grid__col--small-12">
                            <div className="grid--12 grid--has-gutter-3x">
                                <Icon icon={{ prefix: "fas", iconName: "bell" }} size="lg" />
                                <Icon icon={{ prefix: "fas", iconName: "envelope" }}  size="lg" />
                            </div>
                        </div>
                        <div className="grid__col--6 grid__col--small-12">
                            {intl.formatMessage("profile.mail.calendar.subject") + intl.formatMessage("profile.mail.calendar.subject.date")}
                        </div>
                        <div className="grid__col--6 grid__col--small-12" style={{marginTop:"-6px"}}>
                            <div className="grid--12 grid--has-gutter-3x">
                                <Checkbox
                                    inputProps={{
                                        key: "notification_alerts",
                                        name: "notification_alerts",
                                        options: [
                                            {
                                                value: "weekly_reminder",
                                                label: ""
                                            }
                                        ]
                                    }}
                                />
                                <Checkbox
                                    inputProps={{
                                        key: "email_alerts",
                                        name: "email_alerts",
                                        options: [
                                            {
                                                value: "weekly_reminder",
                                                label: ""
                                            }
                                        ]
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="grid--12 grid--has-gutter-3x margin-top--6">
                        <div className="grid__col--6 grid__col--small-12">
                            <h3 className="text-color--primary bold">Ma distance max. d'intervention</h3>
                        </div>
                    </div>
                    <div className="grid--12 grid--has-gutter-3x">
                        <div className="grid__col--3 grid__col--small-12">
                            <Slider
                                inputProps={{
                                    name: "travel_range",
                                    min: 5,
                                    max: 100,
                                    step: 5,
                                    unit: "km"
                                }}
                            />
                        </div>
                    </div>

                    <div className="text-center margin-top--5">
                        <Button className="btn btn--primary" type="submit" disabled={submitting}>
                            {intl.formatMessage("generic.action.save")}
                            {submitting ? <div className="loader-inner" /> : null}
                        </Button>
                    </div>
                </form>
            )}
        />
    );
};

export default MyPreferences;
